export default __webpack_public_path__ + "static/media/elect1.f1fa3819.jpg";